export function findCookieByName(name) {
  const cookies = window.document.cookie.split(";")
  let value = null

  for (const c of cookies) {
    if (c.includes(name)) {
      value = c.split("=")[1]
      break
    }
  }

  return value
}
export function findCookieByNameWithPrefix(name) {
  return findCookieByName(addPrefix(name))
}

function addPrefix(name) {
  return `${window.COOKIES_NAME_PREFIX}${name}`
}

export function deleteCookieByName(name) {
  document.cookie = `${addPrefix(name)}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}